import { Fragment, useMemo } from "react";
import { Breadcrumbs } from "../../../AbstractElements";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import HeaderCard from "../../../Components/Common/Component/HeaderCard";
import { useDataFetch } from "../../Hooks/Use-data-fetch";
import DataTable from "../../Components/DataTable"; 
import { createColumnHelper } from "@tanstack/react-table";

export const SubscriberList = () => {
   const { getData } = useDataFetch();
  
    const { data, isLoading } = getData(
      ["subscribers"],
      "/subscribers",
      {
        enabled: true,
      }
    );

      
    
  const columnHelper = createColumnHelper();

  const columns = useMemo(() => [
    columnHelper.accessor("name", { header: "Nombre" }),
    columnHelper.accessor("email", { header: "Correo" }), 
    columnHelper.accessor("state", { 
        header: "Estado",
        cell: info => {
          const state = info.getValue();
          return state? "Activo" : "Inactivo";
        }
      }),
    columnHelper.accessor("created_at", {
        header: "Fecha",
        cell: info => {
        const rawDate = info.getValue();
        const date = new Date(rawDate);
        return date.toLocaleDateString(); 
        }
    }),
  ], [columnHelper]);

   
  return (
    <Fragment>
      <Breadcrumbs parent="Usuarios" title="Suscriptores" mainTitle="Suscriptores" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <HeaderCard title="Suscriptores registrados" />
              <CardBody>
                  <DataTable data={data?.data?.subscribers??[]} columns={columns} progressPending={isLoading} />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
}